export default __webpack_public_path__ + "static/media/cmc.abd1046f.svg";